/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect } from 'react';
import { AgentIcon, agentSelect, Wrapper } from './styled';
import Select from 'react-select';
import { ThemeContext } from 'Context';
import { useDispatch, useSelector } from 'react-redux';
import { getAgentsExecutions, setAgentExecutionsType } from 'store/Agents/actions';
import { selectAgentExecutionType } from 'store/Agents/selectors';

const AgentSelector = () => {
  const dispatch = useDispatch();
  const { themeStyles } = useContext(ThemeContext);
  const agentType = useSelector(selectAgentExecutionType);

  const onChange = (e) => {
    dispatch(setAgentExecutionsType(e.value));
  };

  const options = [
    {
      label: 'Local Runners',
      value: 'agent_executions'
    },
    {
      label: 'Security Scanners',
      value: 'cloud_agent_executions'
    }
  ];

  const labels = {
    agent_executions: 'Local Runners',
    cloud_agent_executions: 'Security Scanners'
  };

  useEffect(() => {
    dispatch(getAgentsExecutions(agentType));
  }, [agentType]);

  return (
    <Wrapper>
        <AgentIcon />
        <Select
          isDisabled
          styles={ agentSelect(themeStyles) }
          isSearchable={ false }
          value={ { label: labels[agentType], value: agentType } }
          onChange={ (e) => onChange(e) }
          options={ options }
        />
    </Wrapper>
  );
};

export default AgentSelector;
